import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_transaction_table = _resolveComponent("transaction-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "tw-mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "5" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("label", null, "From: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.fromDate]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "5" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "To: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.toDate]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.searchData,
                color: "primary",
                elevation: "2"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Search", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "tw-mt-4" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.statusMsg), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "tw-mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_transaction_table, {
            "table-data": _ctx.tableData,
            rowIds: _ctx.rowIds,
            isEditable: true
          }, null, 8, ["table-data", "rowIds"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}